import React, { useState, useEffect } from "react";
import { Navigation } from "../components/navigation";
import { Header } from "../components/header";
import { Contact } from "../components/contact";
import JsonData from "../data/data.json";
import SmoothScroll from "smooth-scroll";
import "../App.css";
import TagManager from 'react-gtm-module';

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const Home = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);
  useEffect(() => {
    const tagManagerArgs = {
        gtmId: 'GTM-TX3VDHC'
    };
    TagManager.initialize(tagManagerArgs);
  }, []);
  return (
    <div>
        <div>
            <Navigation />
            <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/>
            <Header data={landingPageData.Clients} />
            {/* <Clients data={landingPageData.Clients} /> */}
            {/* <Features data={landingPageData.Features} /> */}
            {/* <Apps data={landingPageData.Apps} /> */}
            {/* <Resources data={landingPageData.Resources} /> */}
            <Contact data={landingPageData.Contact} />
        </div>    
    </div>
  );
};  

export default Home;
